import { makeStateKey } from "@angular/platform-browser";
import { HttpResponse, } from "@angular/common/http";
import { of } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
export class BrowserStateInterceptor {
    constructor(transferState) {
        this.transferState = transferState;
    }
    intercept(req, next) {
        if (req.method !== "GET") {
            return next.handle(req);
        }
        const storedResponse = this.transferState.get(makeStateKey(req.url), null);
        if (storedResponse) {
            const response = new HttpResponse({ body: storedResponse, status: 200 });
            return of(response);
        }
        return next.handle(req);
    }
}
BrowserStateInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BrowserStateInterceptor_Factory() { return new BrowserStateInterceptor(i0.ɵɵinject(i1.TransferState)); }, token: BrowserStateInterceptor, providedIn: "root" });
